import QueryBase from './QueryBase';
/**
 * 顺序执行策略, 解析出什么，就往外发什么东西
 *
 * @export
 * @class QueryNormal
 * @extends {QueryBase}
 */
export default class QueryNormal extends QueryBase {
  constructor() {
    super();
  }

  async query(start, end) {
    // 返回[start,end]之间的数据

    let result = await this.dbController.select([
      { key: 'time', value: start, compare: '>', optional: true },
      { key: 'time', value: end, compare: '<' },
      { key: 'uid', value: 0, compare: '>=' }
    ]);

    return result || [];
  }
}
